/** Placeholder mount point for the public appeal contact form (hydrated on the directory site). */
export const FUNDING_APPEAL_CONTACT_FORM_ATTR = "data-mixitone-funding-contact-form";

const DEFAULT_INBOUND_DOMAIN = "funding.mixitone.com";

/** Appeal import / public contact address: `appeal+<appeal_uuid>@<domain>`. */
export function fundingAppealInboundEmailAddress(
  appealId: string,
  inboundEmailDomain: string = DEFAULT_INBOUND_DOMAIN,
): string {
  const id = appealId.trim();
  const domain = inboundEmailDomain.trim() || DEFAULT_INBOUND_DOMAIN;
  return `appeal+${id}@${domain}`;
}

export type ResolveFundingLandingPageMarkersOptions = {
  appealId: string;
  inboundEmailDomain?: string;
};

/**
 * Ensures published landing HTML has working appeal contact wiring: strips legacy self-link CTAs,
 * normalizes mailto appeal addresses, and tags contact-form mount points with the appeal id.
 */
export function resolveFundingLandingPageMarkers(
  html: string,
  options: ResolveFundingLandingPageMarkersOptions,
): string {
  const appealId = options.appealId.trim();
  if (!appealId) return html;

  const mailto = `mailto:${fundingAppealInboundEmailAddress(appealId, options.inboundEmailDomain)}`;
  let out = html;

  // Legacy self-link CTAs from older AI drafts: drop the useless button, keep surrounding copy.
  out = out.replace(/<a\b[^>]*\bdata-mixitone-funding-cta="appeal_landing"[^>]*>[\s\S]*?<\/a>/gi, "");

  const contactAttr = FUNDING_APPEAL_CONTACT_FORM_ATTR;
  out = out.replace(new RegExp(`(<div\\b[^>]*\\b${contactAttr}=")[^"]*(")`, "gi"), `$1${appealId}$2`);
  out = out.replace(/mailto:appeal\+[0-9a-f-]{36}@[^"'\s>]+/gi, mailto);

  return out;
}
